module.exports = __webpack_public_path__ + "static/media/bulldozer_orange.c84cbb60.svg";